import React, {Component} from 'react';
import styles from './Footer.module.sass';
import logo from '../../assets/images/logo-caixaseguradora.png';
import AppContext from "../../contexts/appContext";

class footer extends Component {

  static contextType = AppContext;

  state = {
    product: null
  }

  render() {
    return (

      <footer className={styles.footer}>
        <img
          className={styles.footerImg}
          src={logo}
          alt="footer page"
        />
        <div className={styles.contact}>
          <p className={styles.text}><span className={styles.textBold}>Fale conosco:</span> 0800 702 4000</p>
          <p className={styles.text}><span className={styles.textBold}>Ouvidoria:</span> 0800 702 4240</p>
          <p className={styles.text}><span className={styles.textBold}>SAC:</span> 0800 702 4280</p>
        </div>
        <div className={styles.copyright}>
          <p className={styles.text}>© Copyright 2017 Caixa Seguradora - Todos os direitos reservados.</p>
          <p className={styles.text}>
            Caixa Seguradora S/A - CNPJ 34.020.254/0001-10 <br />
            Edifício Sede: SHN Quadra 01, Conjunto A, Bloco E <br />
            Brasília/DF - CEP: 70.701-050 <br />
            O registro deste plano na SUSEP não implica, por parte da Autarquia, incentivo ou
            recomendação à sua comercialização. <br />
            Processo SUSEP nº 15414.900040/2016-34.</p>
        </div>
      </footer>
    )

  }
}

export default footer;
